import { type FC, isValidElement, type ReactNode } from 'react';

import { detectCardType } from './types';

interface CardBlockquoteProps {
  children?: ReactNode;
}

function extractTextContent(children: ReactNode): string {
  if (typeof children === 'string') {
    return children;
  }
  if (typeof children === 'number') {
    return String(children);
  }
  if (Array.isArray(children)) {
    return children.map(extractTextContent).join('');
  }
  if (isValidElement(children)) {
    const nested = (children.props as { children?: ReactNode }).children;
    if (nested) {
      return extractTextContent(nested);
    }
  }
  return '';
}

export const CardBlockquote: FC<CardBlockquoteProps> = ({ children }) => {
  const cardType = detectCardType(extractTextContent(children));
  if (!cardType) {
    return <blockquote className="standard-blockquote">{children}</blockquote>;
  }

  return (
    <div className={`card-block card-${cardType}`}>
      <div className="card-content">{children}</div>
    </div>
  );
};
